import * as z from 'zod';

import { countryQuerySchema } from '../countries';

export const phoneNumberQuerySchema = z.object({
  id: z.number(),
  number: z.string(),
  type: z.string(),

  ext: z.number().nullish(),
  created_at: z.string(),
  updated_at: z.string(),

  country_id: z.number(),
  country: countryQuerySchema,
});

export type PhoneNumberQuerySchema = z.infer<typeof phoneNumberQuerySchema>;
